<template>
  <router-view />
</template>

<style lang="scss">
@import "~bulma/css/bulma.css";
</style>
